<div
  id="organization-identity"
  class="page-layout simple left-sidebar inner-sidebar inner-scroll"
>
  <!-- HEADER -->
  <div class="gt2-theme">
    <div
      class="header accent py-24 pl-24 pr-8 mat-elevation-z1 identity-header"
    >
      <div class="flex-row-start-center">
        <button
          class="mr-0 mr-sm-16 white-fg"
          mat-icon-button
          (click)="onBack()"
        >
          <mat-icon class="icon-mat">arrow_back</mat-icon>
        </button>
        <mat-icon class="header-page-icon">account_balance</mat-icon>
        <div class="flex-column-start-start">
          <div class="identity-title">
            <span class="text-truncate">
              {{ isCreate ? ("ORG.IDENTITY_NEW" | translate) : identity.name }}
            </span>
          </div>
          <div class="flex-row-start-start identity-subtitle">
            {{ "ORG.IDENTITY_TITLE" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="content">
    <div class="center p-24 pb-56">
      <div class="identity-content flex-column">
        <!-- INFORMATION -->
        <div class="profile-box info-box general mt-12 flex-column">
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">
                {{ "GENERIC.GENERAL_INFORMATION" | translate }}
              </div>
            </header>
          </div>
          <div class="box-content">
            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "ORG.IDENTITY_NAME" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.name"
                  required
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.WEBSITE" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.website"
                />
              </mat-form-field>
            </div>

            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.FACEBOOK" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.facebook_url"
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.TWITTER" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.twitter_url"
                />
              </mat-form-field>
            </div>

            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.LINKEDIN" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.linkedin_url"
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.INSTAGRAM" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.instagram_url"
                />
              </mat-form-field>
            </div>

            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.YOUTUBE" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.youtube_url"
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.TELEGRAM" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.telegram_url"
                />
              </mat-form-field>
            </div>

            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.TIKTOK" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.tiktok_url"
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.WHATSAPP" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.whatsapp_url"
                />
              </mat-form-field>
            </div>

            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.PINTEREST" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.pinterest_url"
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "GENERIC.THREADS" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.threads_url"
                />
              </mat-form-field>
            </div>

            <div class="identity-form-row">
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "ORG.SUPPORT_EMAIL" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.support_email"
                />
              </mat-form-field>
              <mat-form-field class="identity-form-col">
                <mat-label>{{ "ORG.SUPPORT_TEL" | translate }}</mat-label>
                <input
                  matInput
                  autocomplete="nope"
                  type="text"
                  [(ngModel)]="identity.support_tel"
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- SIGNATURE -->
        <div class="profile-box info-box general mt-12 flex-column">
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "ORG.SIGNATURE" | translate }}</div>
            </header>
          </div>
          <div class="box-content">
            <app-signature-rich-editor
              [editMode]="true"
              [(signatureFr)]="identity.signature_fr_CA"
              [(signatureEn)]="identity.signature_en_CA"
            ></app-signature-rich-editor>
          </div>
        </div>

        <!-- COLORS -->
        <div class="profile-box info-box general mt-12 flex-column">
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "ORG.IDENTITY_COLORS" | translate }}</div>
            </header>
          </div>
          <div class="box-content">
            <!-- Email header color -->
            <div class="color-field">
              <div class="color-field-label">
                {{ "ORG.IDENTITY_EMAIL_BG_COLOR" | translate }}
              </div>
              <div class="flex-row-start-center color-field-controls">
                <ngx-colors
                  *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
                  ngx-colors-trigger
                  [(ngModel)]="emailBgColor"
                  [style.background]="
                    identity.email_background_color || '#ffffff'
                  "
                  (change)="setEmailBgColor($event)"
                  [palette]="colorPalette"
                  [hideColorPicker]="true"
                  [hideTextInput]="false"
                ></ngx-colors>
                <div
                  class="color-preview"
                  *ngIf="identity.email_background_color"
                  [style.background]="identity.email_background_color"
                >
                  <span>Aa</span>
                </div>
                <ng-container *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES">
                  <button
                    mat-button
                    *ngIf="identity.email_background_color"
                    (click)="clearEmailBgColor()"
                  >
                    {{ "ORG.EMAIL_BG_COLOR_CLEAR" | translate }}
                  </button>
                </ng-container>
              </div>
              <div class="color-field-help">
                {{ "ORG.IDENTITY_EMAIL_BG_COLOR_HELP" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- LOGOS -->
        <div class="profile-box info-box general mt-12 flex-column">
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "ORG.GRAPHICS" | translate }}</div>
            </header>
          </div>
          <div class="box-content">
            <div *ngIf="!canEditLogos" class="logo-save-first">
              {{ "ORG.IDENTITY_SAVE_FIRST" | translate }}
            </div>
            <div class="logo-upload-row" [class.logo-disabled]="!canEditLogos">
              <!-- Logo White -->
              <div class="logo-upload-block">
                <div class="logo-block-title">
                  {{ "ORG.LOGO_WHITE" | translate }}
                </div>
                <div class="logo-preview-container logo-preview-dark">
                  <img
                    *ngIf="identity.logo_white"
                    [src]="identity.logo_white"
                    alt="Logo White"
                    class="logo-preview-img"
                  />
                  <div *ngIf="!identity.logo_white" class="logo-placeholder">
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <div class="logo-requirement">
                  {{ "ORG.LOGO_PNG_ONLY" | translate }}
                </div>
                <input
                  type="file"
                  accept="image/png"
                  #logoWhiteInput
                  style="display: none"
                  (change)="
                    onLogoFileSelected($event, ASSET_TYPE_IDENTITY_WHITE)
                  "
                />
                <button
                  *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
                  mat-raised-button
                  color="accent"
                  class="mt-8"
                  [disabled]="!canEditLogos || logoWhiteUploading"
                  (click)="onSelectLogoFile(ASSET_TYPE_IDENTITY_WHITE)"
                >
                  <mat-icon class="mr-4">cloud_upload</mat-icon>
                  {{ "ORG.UPLOAD_LOGO_TYPE" | translate }}
                </button>
                <mat-progress-bar
                  *ngIf="logoWhiteUploading"
                  mode="indeterminate"
                  class="mt-8"
                ></mat-progress-bar>
              </div>

              <!-- Logo Color -->
              <div class="logo-upload-block">
                <div class="logo-block-title">
                  {{ "ORG.LOGO_COLOR" | translate }}
                </div>
                <div class="logo-preview-container logo-preview-light">
                  <img
                    *ngIf="identity.logo_color"
                    [src]="identity.logo_color"
                    alt="Logo Color"
                    class="logo-preview-img"
                  />
                  <div *ngIf="!identity.logo_color" class="logo-placeholder">
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <div class="logo-requirement">
                  {{ "ORG.LOGO_PNG_ONLY" | translate }}
                </div>
                <input
                  type="file"
                  accept="image/png"
                  #logoColorInput
                  style="display: none"
                  (change)="
                    onLogoFileSelected($event, ASSET_TYPE_IDENTITY_COLOR)
                  "
                />
                <button
                  *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
                  mat-raised-button
                  color="accent"
                  class="mt-8"
                  [disabled]="!canEditLogos || logoColorUploading"
                  (click)="onSelectLogoFile(ASSET_TYPE_IDENTITY_COLOR)"
                >
                  <mat-icon class="mr-4">cloud_upload</mat-icon>
                  {{ "ORG.UPLOAD_LOGO_TYPE" | translate }}
                </button>
                <mat-progress-bar
                  *ngIf="logoColorUploading"
                  mode="indeterminate"
                  class="mt-8"
                ></mat-progress-bar>
              </div>
            </div>
          </div>
        </div>

        <!-- DEFAULT PRODUCT IMAGE -->
        <div class="profile-box info-box general mt-12 flex-column">
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">
                {{ "ORG.PRODUCT_DEFAULT_IMAGE" | translate }}
              </div>
            </header>
          </div>
          <div class="box-content">
            <div *ngIf="!canEditLogos" class="logo-save-first">
              {{ "ORG.IDENTITY_SAVE_FIRST" | translate }}
            </div>
            <div class="logo-upload-row" [class.logo-disabled]="!canEditLogos">
              <div class="logo-upload-block">
                <div class="product-preview-container">
                  <img
                    *ngIf="identity.product_default_image"
                    [src]="identity.product_default_image"
                    alt="Default product image"
                    class="logo-preview-img"
                  />
                  <div
                    *ngIf="!identity.product_default_image"
                    class="logo-placeholder"
                  >
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <div class="logo-requirement">
                  {{ "ORG.PRODUCT_DEFAULT_PNG_ONLY" | translate }}
                </div>
                <input
                  type="file"
                  accept="image/png"
                  #productDefaultInput
                  style="display: none"
                  (change)="onProductImageSelected($event)"
                />
                <button
                  *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
                  mat-raised-button
                  color="accent"
                  class="mt-8"
                  [disabled]="!canEditLogos || productDefaultUploading"
                  (click)="onSelectProductImage()"
                >
                  <mat-icon class="mr-4">cloud_upload</mat-icon>
                  {{ "ORG.UPLOAD_LOGO_TYPE" | translate }}
                </button>
                <mat-progress-bar
                  *ngIf="productDefaultUploading"
                  mode="indeterminate"
                  class="mt-8"
                ></mat-progress-bar>
              </div>
            </div>
          </div>
        </div>

        <!-- SAVE -->
        <div class="mt-16 flex-row-end-start">
          <button
            *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
            mat-raised-button
            color="accent"
            class="save-btn"
            [disabled]="!formValid || saving"
            (click)="onSave()"
          >
            {{ "GENERIC.SAVE" | translate }}
          </button>
        </div>

        <!-- ADDRESS -->
        <div
          *ngIf="!isCreate"
          class="profile-box info-box general mt-12 flex-column"
        >
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "GENERIC.ADDRESS" | translate }}</div>
            </header>
          </div>
          <div class="">
            <app-address
              #addressComponent
              [groupModel]="identity.address"
              [isVisible]="true"
              [allowPoBox]="true"
              [editMode]="editMode"
              [useAutosave]="false"
              class=""
            ></app-address>
          </div>
        </div>

        <!-- CONTACT -->
        <div
          *ngIf="!isCreate"
          class="profile-box info-box general mt-12 flex-column"
        >
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "GENERIC.CONTACT" | translate }}</div>
            </header>
          </div>
          <div class="">
            <app-contact
              #contactComponent
              [groupModel]="identity.contact"
              [editMode]="editMode"
              [useAutosave]="false"
              class=""
            >
            </app-contact>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- EDIT ADDRESS & CONTACT -->
<div *ngIf="!isCreate" class="flex-row-end-start">
  <div class="fixed-button">
    <button
      *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
      mat-fab
      appEditShortcut
      class="gt2-edit-button"
      id="edit-identity-button"
      [disabled]="loading"
      matTooltip="{{ 'GENERIC.EDIT' | translate }} (F2)"
      (click)="onEditAddressContact()"
    >
      <mat-icon *ngIf="!editMode" class="icon-mat-black">{{
        getIcon("EDIT_FAB")
      }}</mat-icon>
      <mat-icon *ngIf="editMode" class="icon-mat-black">{{
        getIcon("UNDO")
      }}</mat-icon>
    </button>
  </div>
</div>
